<template>
    <div>
        <div class="row_center_between w-full">
            <div class="row_center_start grow truncate">
                <div class="grow truncate">
                    <text>{{ product.name }}</text>
                    <text class="shrink-0" v-if="product['altAddonPrice'] !== undefined && product.altAddonPrice !== 0">+{{
                        product.altAddonPrice }}</text>
                    <!-- 一般餐點規格價格 -->
                    <text class="shrink-0"
                        v-else-if="product['altAddonPrice'] === undefined && product.price !== 0 && !isProduct">{{
                        product.price > 0 ? `+${product.price}` : product.price }}</text>
                </div>
                <text class="text-primary-color text-base"
                    v-if="editable" @click="openCustomizePopup">選擇規格</text>
            </div>
        </div>
        <div class="column_start_start customized_options" v-if="isSelected && customizedText">
            {{ customizedText }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        product: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
        editable: {
            type: Boolean,
            default: false,
            required: false,
        },
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isProduct() {
            return this.products.find(item => item.id === this.product.id)
        },
        products() {
            return this.$store.getters['spreadsheet/products']
        },
        customizedText() {
            if (this.product.productSpecSettings === undefined) return '';
            let customizedText = '';
            this.product.productSpecSettings.forEach(el => {
                if (el.subSpecOptionSelectCount !== undefined) {
                    const totalCount = el.subSpecOptionSelectCount.reduce((acc, option) => acc + option, 0)
                    if (totalCount === 0) return;
                    let text = el.subSpecOptionSelectCount.reduce((text, count, index) => {
                        if (el.specOptions === undefined || count === 0) return text;
                        return text += `${el.specOptions[index].name} ${count > 1 ? `x${count}` : ''}/`;
                    }, '');
                    if (text) {
                        customizedText += `${el.frontEndDisplayName}：${text.slice(0, -1)}、`;
                    }
                }
            });
            return customizedText ? customizedText.slice(0, -1) : '';
        }
    },
    methods: {
        openCustomizePopup() {
            this.$emit("openCustomizePopup");
        }
    }
}
</script>
<style lang="">

</style>